import Swiper from 'swiper';
import { Autoplay, FreeMode, A11y } from 'swiper/modules';

function initCustomerSlider(section) {
    const swiperEl = section.querySelector('.swiper');
    if (!swiperEl || swiperEl.swiper) return;

    // Equal-width cells (numeric slidesPerView) — this is what keeps loop +
    // autoplay stable. Each logo is capped at 180×82 and centered in its cell
    // via style.css. Paired with the linear timing override for a smooth marquee.
    new Swiper(swiperEl, {
        modules: [Autoplay, FreeMode, A11y],
        slidesPerView: 2,
        spaceBetween: 32,
        loop: true,
        grabCursor: true,
        speed: 5000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        freeMode: true,
        a11y: { enabled: true },
        breakpoints: {
            640: { slidesPerView: 3, spaceBetween: 48 },
            768: { slidesPerView: 4, spaceBetween: 64 },
            1280: { slidesPerView: 4, spaceBetween: 80 },
        },
    });
}

function init() {
    document.querySelectorAll('[data-customer-slider]').forEach(initCustomerSlider);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
